import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClientOnboardinglistComponent } from './client-onboardinglist.component';

export const routes = [
  { path: '', component: ClientOnboardinglistComponent,       }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientOnboardingListRoutingModule { }
